import SectionHeader from './SectionHeader';

const STATS = [
  { value: '4 类', label: '尺度判定维度', note: '从视觉到语境分层' },
  { value: '5 档', label: '处罚阶梯', note: '从提醒到永久封禁' },
  { value: '60s+', label: '案例复盘路径', note: '一次违规如何蔓延' },
  { value: '3 步', label: '下架后自救', note: '整改与申诉顺序' },
];

const CHANNELS = [
  {
    href: '#boundary',
    icon: 'ri-ruler-line',
    tag: '01 规则向',
    title: '尺度边界',
    desc: '平台从哪些维度判断「越没越线」，视觉、文案、行为、语境四类怎么量化。',
    chip: '判定维度拆解',
  },
  {
    href: '#cases',
    icon: 'ri-error-warning-line',
    tag: '02 案例向',
    title: '违规案例',
    desc: '挑选代表性场景复盘：从上传、限流到被处理，整条链路哪里先亮红灯。',
    chip: '场景还原式复盘',
  },
  {
    href: '#reasons',
    icon: 'ri-archive-drawer-line',
    tag: '03 处置向',
    title: '下架原因',
    desc: '一次「被下架」背后常藏着哪些共性理由，哪些会被整改、哪些直接封禁。',
    chip: '处置理由溯源',
  },
  {
    href: '#checklist',
    icon: 'ri-file-list-3-line',
    tag: '04 避坑向',
    title: '发布自查',
    desc: '发之前逐条过一遍的清单，把可能被判定「擦边」的点提前拦下来。',
    chip: '上架前自查表',
  },
];

export default function Overview() {
  return (
    <section id="channel" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100/60 px-5 py-4"
            >
              <span className="font-serif text-3xl font-black text-primary-500 md:text-4xl">{s.value}</span>
              <span className="min-w-0">
                <span className="block text-sm font-bold text-foreground-950">{s.label}</span>
                <span className="block truncate text-xs text-foreground-600">{s.note}</span>
              </span>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-20">
          <SectionHeader
            eyebrow="内容总览"
            title="一个站，四条线"
            desc="把「擦边到底擦在哪」拆成可检索的四个栏目，想弄清哪一块，直接往下翻对应段落。"
          />
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {CHANNELS.map((c) => (
            <a
              key={c.title}
              href={c.href}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500/10 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-2xl`} />
              </span>
              <p className="mt-5 text-xs font-bold tracking-widest text-accent-600">{c.tag}</p>
              <h3 className="mt-1.5 flex items-center gap-1.5 font-serif text-xl font-bold text-foreground-950">
                {c.title}
                <i className="ri-arrow-right-line text-accent-600 transition-transform group-hover:translate-x-1" />
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
                {c.chip}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}